<template>
  <div
    class="flex items-center justify-between p-4"
    :class="{ 'border-b': isOpen }"
    @click="isOpen = !isOpen"
  >
    <div>
      <div class="flex items-start">
        <icon-base
          :icon="IconBullet"
          :icon-color="
            currentAgencyHasHits ? UTIL_COLORS.ERROR : UTIL_COLORS.SUCCESS
          "
          class="mt-1.5"
        />
        <div>
          <lf-h4>{{ agency.name }}</lf-h4>
          <p class="text-gray-400">{{ agency.org }}</p>
        </div>
      </div>
    </div>
    <icon-chevron-up
      class="mt-1 mr-4 transform cursor-default transition-all"
      :class="{ 'rotate-180': isOpen }"
    />
  </div>
  <div v-if="isOpen" class="grid grid-cols-3 gap-x-5 gap-y-4 p-4">
    <div v-for="(list, i) in currentAgency" :key="i">
      <middesk-watchlist-entry :list="list" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

import { UTIL_COLORS } from "@/helpers/constants";

import IconBullet from "@/components/icons/IconBullet.vue";
import MiddeskWatchlistEntry from "@/views/businessCreditDeals/components/MiddeskWatchlistEntry.vue";

import type { Agency, IMiddeskResponse } from "@/models/commercialData/Middesk";
import type { PropType } from "vue";

const props = defineProps({
  forceOpen: {
    type: Boolean,
    required: false,
  },
  agency: {
    type: Object as PropType<Agency>,
    required: true,
  },
  middeskData: {
    type: Object as PropType<IMiddeskResponse>,
    required: true,
  },
});

const isOpen = ref(props.forceOpen);

const currentAgency = computed(() =>
  props.middeskData.watchlist?.lists.filter(
    (list) => list.agency === props.agency.name
  )
);

const currentAgencyHasHits = computed(() =>
  currentAgency.value?.some((record) => record.results.length)
);

watch(
  () => props.forceOpen,
  (value) => (isOpen.value = value)
);
</script>
